import React from "react";

const PrintTableOfContents = ({ disclaimer, issueItems, pageNumbers }) => {
  const reportIntroEntries = [];

  if (disclaimer) {
    reportIntroEntries.push({
      label: "Inspection Scope & Disclaimer",
      anchor: "inspection-scope-disclaimer",
    });
  }
  reportIntroEntries.push({
    label: "Definitions & Glossary",
    anchor: "definitions-glossary",
  });

  const overviewSummaryEntries = [
    { label: "Inspection Overview", anchor: "inspection-overview" },
    { label: "Challenge Summary", anchor: "challenge-summary-section" },
  ];

  const inspectionEntries = [
    { label: "Property Details", anchor: "property-details" },
    ...(issueItems || []).map((section) => ({
      label: section.name,
      anchor: `section-${section.name?.toLowerCase().replace(/\s+/g, "-")}`,
    })),
  ];

  const renderCategory = (title, entries) => (
    <div className="print-toc-category">
      <div className="print-toc-category-title">{title}</div>
      {entries.map((entry) => (
        <div key={entry.anchor} className="print-toc-entry">
          <span className="print-toc-entry-label">{entry.label}</span>
          <span className="print-toc-entry-dots" />
          <span className="print-toc-entry-page">
            {pageNumbers?.[entry.anchor] ?? ""}
          </span>
        </div>
      ))}
    </div>
  );

  return (
    <div className="print-toc-container">
      <h1 className="print-toc-title">Table of Contents</h1>
      {renderCategory("REPORT & INTRODUCTION", reportIntroEntries)}
      {renderCategory("OVERVIEW & SUMMARY", overviewSummaryEntries)}
      {renderCategory("INSPECTION", inspectionEntries)}
    </div>
  );
};

export default PrintTableOfContents;
